import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";
import Status               from "dashboard/dist/Core/Status";
import Utils                from "dashboard/dist/Utils/Utils";

// Components
import EditDialog           from "dashboard/dist/Components/EditDialog";
import InputField           from "dashboard/dist/Components/InputField";

// Actions
import {
    fetchRoom, editRoom,
} from "Actions/Admin/Location/RoomActions";



/**
 * The Location Room Edit Dialog
 */
class RoomEdit extends React.Component {
    // The Initial Data
    initialData = {
        locationID       : 0,
        roomID           : 0,
        name             : "",
        floor            : "",
        forStreches      : 0,
        forConversations : 0,
        forMeetings      : 0,
        status           : Status.getID("ACTIVE"),
        observations     : "",
    }

    // The Current State
    state = {
        loading : false,
        data    : { ...this.initialData },
        errors  : {},
    }



    /**
     * Get the Data when the Element ID changes
     * @param {Object} prevProps
     * @returns {Void}
     */
    componentDidUpdate(prevProps) {
        const { open, edition, elemID, elem, locationID, fetchRoom } = this.props;
        let loading = false;
        let data    = null;

        // Dialog Opens
        if (open && !prevProps.open) {
            data = { ...this.initialData };
            // Load new data
            if (elemID) {
                fetchRoom(elemID);
                loading = true;
            } else if (locationID) {
                data.locationID = locationID;
            }

        // Data Updated
        } else if (prevProps.edition !== edition && elemID) {
            data = Utils.extend(this.initialData, elem);
        }

        // Set the State
        if (data) {
            this.setState({ data, loading, errors : {} });
        }
    }

    /**
     * Handles the Input Change
     * @param {String} name
     * @param {*}      value
     * @returns {Void}
     */
    handleChange = (name, value) => {
        this.setState({
            data   : { ...this.state.data,   [name] : value },
            errors : { ...this.state.errors, [name] : ""    },
        });
    }

    /**
     * Handles the Submit
     * @returns {Promise}
     */
    handleSubmit = async () => {
        const { data, loading } = this.state;
        if (!loading) {
            this.setState({ loading : true, errors : {} });
            try {
                await this.props.editRoom(data);
                this.setState({ loading : false });
                this.props.onSubmit();
            } catch (errors) {
                this.setState({ loading : false, errors });
            }
        }
    }



    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { elemID, open, onClose } = this.props;
        const { data, loading, errors } = this.state;

        return <EditDialog
            open={open}
            icon="room"
            title={!!elemID ? "ROOMS_EDIT_TITLE" : "ROOMS_CREATE_TITLE"}
            error={errors.form}
            onSubmit={this.handleSubmit}
            onClose={onClose}
            isLoading={loading}
        >
            <InputField
                name="name"
                label="ROOMS_ITS_NAME"
                value={data.name}
                error={errors.name}
                onChange={this.handleChange}
                isRequired
            />
            <InputField
                type="number"
                name="floor"
                label="ROOMS_ITS_FLOOR"
                value={data.floor}
                error={errors.floor}
                onChange={this.handleChange}
            />
            <InputField
                type="select"
                name="status"
                label="GENERAL_STATUS"
                value={data.status}
                error={errors.status}
                onChange={this.handleChange}
                options={Status.getSelect()}
                withNone
                isRequired
                shrinkLabel
            />
            <InputField
                type="textarea"
                name="observations"
                label="GENERAL_OBSERVATIONS"
                value={data.observations}
                onChange={this.handleChange}
            />
            <InputField
                type="toggle"
                name="forStreches"
                label="LOCATIONS_FOR_STRECHES"
                value={!!data.forStreches}
                onChange={this.handleChange}
            />
            <InputField
                type="toggle"
                name="forConversations"
                label="LOCATIONS_FOR_CONVERSATIONS"
                value={!!data.forConversations}
                onChange={this.handleChange}
            />
            <InputField
                type="toggle"
                name="forMeetings"
                label="LOCATIONS_FOR_MEETINGS"
                value={!!data.forMeetings}
                onChange={this.handleChange}
            />
        </EditDialog>;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        fetchRoom  : PropTypes.func.isRequired,
        editRoom   : PropTypes.func.isRequired,
        open       : PropTypes.bool.isRequired,
        onClose    : PropTypes.func.isRequired,
        onSubmit   : PropTypes.func.isRequired,
        edition    : PropTypes.number.isRequired,
        elem       : PropTypes.object.isRequired,
        elemID     : PropTypes.number,
        locationID : PropTypes.number,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            edition : state.locRoom.edition,
            elem    : state.locRoom.elem,
        };
    }
}

export default connect(RoomEdit.mapStateToProps, {
    fetchRoom, editRoom,
})(RoomEdit);
